import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import { Link, Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

export class RegistrationResponse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            success: false,
            errorMessage: null
        };
        this.submitToken = this.submitToken.bind(this);
        this.submitTokenCallback = this.submitTokenCallback.bind(this);
        this.submitTokenErrorCallback = this.submitTokenErrorCallback.bind(this);
    }

    componentDidMount() {
        const token = this.props.params.token;
        this.submitToken(token);
    }

    submitTokenErrorCallback(data, status) {
        this.setState({ errorMessage: data && data.detail });
    }


    submitTokenCallback(data) {
        if (!!!data) {
            this.setState({ success: false });
            return;
        }

        if (data.detail) {
            this.setState({ success: false, errorMessage: data.detail });
            return;
        }
        // 2026-05-26: registration now auto-logs-in on token confirmation.
        // No separate login step required.
        if (data.is_authenticated && this.props.authenticator) {
            this.props.authenticator.user = data;
            if (this.props.authenticator.loadAssetsAndSetIsAuthenticated) {
                this.props.authenticator.loadAssetsAndSetIsAuthenticated();
            }
        }
        this.setState({ success: true });
    }

    submitToken(token) {
        this.props.authenticator.queuedPost(
            'user_registration_confirm',
            { token },
            this.submitTokenCallback,
            this.submitTokenErrorCallback);
    }

    render() {
        if (this.state.success) {
            return <Navigate to={'/'}/>;
        }

        if (!this.state.errorMessage) {
            return <Container style={{color: 'white'}}>
                <h1>Validating... Please stand by.</h1>
            </Container>
        }

        return (
            <Container style={{color: 'white'}}>
                <div>RegistrationFailure - {this.state.errorMessage} <Link to="/">Home</Link></div>
            </Container>
        );
    }
}

RegistrationResponse.propTypes = {
    authenticator: PropTypes.object.isRequired
};


export default (props) => {
    let params = useParams();
    const searchParams = useSearchParams();
    let location = useLocation();
    return <RegistrationResponse {...props}
                                 params={params}
                                 location={location}
                                 searchParams={searchParams}/>;
}
